import { render, staticRenderFns } from "./LmDataTableNewOrEdit.vue?vue&type=template&id=6634556a"
import script from "./LmDataTableNewOrEdit.vue?vue&type=script&lang=js"
export * from "./LmDataTableNewOrEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports